
<div class="user-menu__container"
  [ngClass]="{'user-menu__container--opened': isOpen}"
  >
  <div class="user-menu" (click)="toggle()">
    <div class="left">
      <app-user-image
        class="user-menu__picture"
        [user]="user"
        [size]="32"
      ></app-user-image>
      <div class="user-menu__infos">
        @if (user) {
          <p class="user-menu__infos-name">
            {{user.firstname}} {{user.lastname}}
          </p>
        }
        <p class="user-menu__infos-email">{{user?.email}}</p>
      </div>
    </div>

    <div class="icon">
      <i class="fa-solid fa-chevron-up"></i>
    </div>
  </div>

  <div class="user-menu__menu">
    <div class="user-menu__menu-item"
      (click)="redirectToCustomerPortal()"
      >
      <i class="fa-solid fa-credit-card"></i>
      <p>{{ 'sidebar.manage-subscription'|transloco }}</p>
    </div>
    <hr/>
    <a class="user-menu__menu-item"
      [href]="getCguHref()"
      target="_blank"
      rel="noopener noreferrer"
      >
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
      <p>{{ 'sidebar.cgu'|transloco }}</p>
    </a>
    <a class="user-menu__menu-item"
      [href]="getPrivacyPolicyHref()"
      target="_blank"
      rel="noopener noreferrer"
      >
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
      <p>{{ 'sidebar.privacy-policy'|transloco }}</p>
    </a>
    <a class="user-menu__menu-item"
      [href]="getLegalNoticeHref()"
      target="_blank"
      rel="noopener noreferrer"
      >
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
      <p>{{ 'sidebar.legal-notice'|transloco }}</p>
    </a>
    <hr/>
    <div class="user-menu__menu-item"
      (click)="logout()"
      >
      <i class="fa-solid fa-arrow-right-from-bracket"></i>
      <p>{{'sidebar.logout'|transloco}}</p>
    </div>
  </div>
</div>

